import React from 'react';
import PropTypes from 'prop-types';
import BreakpointObserver, { sizes } from '@decisiv/breakpoint-observer';
import { P } from '@decisiv/ui-components/lib/components/Typography';
import Button from '@decisiv/ui-components/lib/components/Button';
import { Badge, H2 } from '@decisiv/ui-components';
import EnvelopeF from '@decisiv/iconix/lib/components/Envelope';

import {
  ButtonsContainer,
  PasswordResetContainer,
} from './components/styledComponents';

// Shown when the username check reports an Auth0 invitation has just been sent.
// Replaces the generic "Authentication failed" flash a PACCAR user used to get.
function CheckYourEmail({ translations, backLoginClick }) {
  const breakpoints = {
    [sizes.SM]: 300,
    [sizes.MD]: 600,
  };

  return (
    <BreakpointObserver breakpoints={breakpoints}>
      {({ observedElementRef }) => (
        <div ref={observedElementRef}>
          <PasswordResetContainer>
            <Badge
              aria-label="envelope badge"
              color="information"
              icon={EnvelopeF}
              size="large"
              palette="bright"
            />
            {/* Rendered only when present: an empty heading or paragraph is
                noise for a screen reader. */}
            {translations.checkYourEmailTitle && (
              <H2 style={{ marginTop: '10px' }}>
                {translations.checkYourEmailTitle}
              </H2>
            )}
            {translations.checkYourEmailInstructions && (
              <P color="alaskanHusky" style={{ textAlign: 'center' }}>
                {translations.checkYourEmailInstructions}
              </P>
            )}
            <ButtonsContainer>
              <Button
                text={translations.backToLogin}
                variant="ghost"
                size="small"
                onClick={backLoginClick}
                style={{ marginTop: '25px' }}
              />
            </ButtonsContainer>
          </PasswordResetContainer>
        </div>
      )}
    </BreakpointObserver>
  );
}

CheckYourEmail.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string),
  backLoginClick: PropTypes.func,
};

CheckYourEmail.defaultProps = {
  translations: {},
  backLoginClick: () => {},
};

export default CheckYourEmail;
